import { useNavigate } from "react-router-dom";
import { INK, MUTED_60, FONT, ROOMS, glow, capsuleStyle } from "@/lib/yuoDesign";

export function UpgradeSheet({ visible, reason, isPro, onClose }) {
  const navigate = useNavigate();
  if (!visible) return null;
  const meta = isPro ? ROOMS.diary : ROOMS.mirror;
  return (
    <div className="yuo-modal-backdrop" onClick={onClose}
      style={{
        position: "fixed", inset: 0, zIndex: 90,
        background: "var(--dk-3410-72)", backdropFilter: "blur(14px)",
        display: "flex", alignItems: "center", justifyContent: "center", padding: 20,
      }}>
      <div onClick={(e) => e.stopPropagation()} data-testid="upgrade-sheet"
        style={{
          maxWidth: 460, width: "100%",
          padding: 28, borderRadius: 28,
          background: `${glow(meta.rgb, 0.16)}, var(--yuo-bg)`,
          boxShadow: `0 0 60px rgba(${meta.rgb},0.28), 0 20px 60px rgba(0,0,0,0.6)`,
          fontFamily: FONT, color: INK,
        }}>
        <div style={{ color: meta.accent, fontSize: 11, letterSpacing: "0.32em", textTransform: "uppercase", marginBottom: 10 }}>
          Unlock YUO {isPro ? "Master" : "Pro"}
        </div>
        <div style={{ color: INK, fontSize: 22, letterSpacing: -0.3, marginBottom: 10 }}>
          A deeper room awaits
        </div>
        <div style={{ color: MUTED_60, fontSize: 13, lineHeight: 1.65, marginBottom: 22 }}>
          {reason}
        </div>
        <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
          <button onClick={() => { onClose(); navigate("/paywall"); }} data-testid="upgrade-cta"
            style={{
              flex: 1, minWidth: 160, padding: "14px 24px", borderRadius: 999, border: "none",
              background: `radial-gradient(120% 160% at 20% 0%, rgba(${meta.rgb},0.34), rgba(${meta.rgb},0.08))`,
              boxShadow: `0 0 34px rgba(${meta.rgb},0.32)`,
              color: INK, fontFamily: FONT, fontSize: 11, letterSpacing: "0.22em", textTransform: "uppercase",
              cursor: "pointer",
            }}>
            See plans
          </button>
          <button onClick={onClose} data-testid="upgrade-dismiss"
            style={capsuleStyle({ active: false, size: "md" })}>
            Not now
          </button>
        </div>
      </div>
    </div>
  );
}
